import { SidebarIcon } from 'lucide-react'
import { Link } from 'react-router-dom'
import { dashboardPath } from '~/common/paths'
import logo from '~/images/spin-logo-horizontal.png'
// import logo from '~/images/spin-logo.svg'

import { SearchForm } from './search-form'
import { Button } from '~/ui/button'
import { Separator } from '~/ui/separator'
import { useSidebar } from '~/ui/sidebar'

export function SiteHeader() {
  const { toggleSidebar } = useSidebar()

  return (
    <header className="bg-background absolute top-0 right-0 left-0 z-50 flex h-12 w-full items-center border-b overflow-hidden">
      <div className="flex h-12 w-full items-center gap-0 px-4 overflow-hidden">
        <div className="flex w-[calc(var(--sidebar-width)-17px)] items-center justify-start overflow-hidden">
          <Button
            className="h-8 w-8 cursor-pointer"
            variant="ghost"
            size="icon"
            onClick={toggleSidebar}
          >
            <SidebarIcon />
          </Button>
          <Separator orientation="vertical" className="mr-2 h-4" />
          <Link to={dashboardPath({})} className="flex items-center overflow-hidden">
            <img src={logo} alt="Logo" className="-ml-2 -mt-1 h-42 max-w-full" />
          </Link>
        </div>
        <Separator orientation="vertical" className="mr-6 h-4" />
        <SearchForm />
        {/* <Separator orientation="vertical" className="mx-6 h-4" />
        <Breadcrumb className="hidden sm:block">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="#">Home</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Dashboard</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb> */}
      </div>
    </header>
  )
}
